import type { JSX } from 'react'
import type { ISearchInputProps } from '../SearchInput'

import { ActionButtonColors } from 'atoms/ActionButton'
import { ButtonIconSizes } from 'atoms/Button'
import { IconNames, IconSizes } from 'atoms/Icon'
import {
  InputActionButtonIndentAdaptive,
  InputActionButtonPosition,
  InputCaretColors,
  InputFontColors,
  InputFonts,
  InputHeight,
  InputNames,
  InputPaddingsAdaptive,
} from 'atoms/Input'
import { SearchInput } from '../SearchInput'

export interface IHybridSearchInputWithDeleteButtonProps extends ISearchInputProps {}

export const HybridSearchInputWithDeleteButton = ({
  name = InputNames.Search,
  value,
  placeholder = '',
  placeholderColor = InputFontColors.TEXT_ICON_SECONDARY,
  font = InputFonts.FontSm,
  colorDefault = InputFontColors.TEXT_ICON_PRIMARY,
  icon = IconNames.close,
  iconSize = ButtonIconSizes.xSm,
  actionButtonPosition = InputActionButtonPosition.Right,
  inputLabelWidth = '100%',
  inputWrapperWidth = '100%',
  height = InputHeight.SIZE_20,
  paddings = InputPaddingsAdaptive.SIZE_10,
  actionButtonColorDefault = ActionButtonColors.COLOR_MAIN_DEFAULT,
  actionButtonColorHovered = ActionButtonColors.SURFACE_LIGHT_2,
  actionButtonColorPressed = ActionButtonColors.COLOR_MAIN_PRESSED,
  autoComplete = 'off',
  caretColor = InputCaretColors.TEXT_ICON_SECONDARY,
  onChange,
  onClick,
  searchIconSize = IconSizes.xSm,
  actionButtonIndent = InputActionButtonIndentAdaptive.SIZE_10,
  ...rest
}: IHybridSearchInputWithDeleteButtonProps): JSX.Element => (
  <SearchInput
    name={name}
    value={value}
    placeholder={placeholder}
    placeholderColor={placeholderColor}
    font={font}
    colorDefault={colorDefault}
    icon={icon}
    iconSize={iconSize}
    actionButtonPosition={actionButtonPosition}
    inputLabelWidth={inputLabelWidth}
    inputWrapperWidth={inputWrapperWidth}
    height={height}
    paddings={paddings}
    actionButtonColorDefault={actionButtonColorDefault}
    actionButtonColorHovered={actionButtonColorHovered}
    actionButtonColorPressed={actionButtonColorPressed}
    autoComplete={autoComplete}
    caretColor={caretColor}
    onChange={onChange}
    onClick={onClick}
    searchIconSize={searchIconSize}
    actionButtonIndent={actionButtonIndent}
    {...rest}
  />
)
